<template>
  <div>
    <div>
      <v-navigation-drawer
        v-model="drawer"
        app
        clipped
        class="d-flex"
        v-if="showMenu && ($vuetify.breakpoint.xs || $vuetify.breakpoint.sm)"
      >
        <div
          class="ma-2 d-flex justify-end"
        >
          <v-btn
            icon
            @click="drawer=false"
          >
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>

        </div>

        <div class="flex-column pl-8 mt-8">
          <nav-link
              to="/"
              :title="$t('navigation_bar.templates')"
          />

        </div>

        <div class="flex-column pl-8 mt-8">
          <nav-link
            to="/feedback"
            :title="$t('navigation_bar.feedback')"
          />
        </div>
        <div  class="flex-column pl-8 mt-8">
        <v-btn
            class="ma-0 pa-0"
            active-class="active-class"
            text
            min-width="0"
            href="https://eu-central-1.console.aws.amazon.com/cognito/users/?region=eu-central-1#/pool/eu-central-1_xK9v60GPR/details"
            >{{$t('navigation_bar.user_management')}}
        </v-btn>
        </div>
        <v-divider class="my-8"/>
        <div class="flex-column pl-8">
          <p>Impressum</p>
          <p>AGBs</p>
        </div>
      </v-navigation-drawer>

      <v-card tile class="d-flex justify-space-between" :class="navBarStyle" >

        <div
          class="d-flex justify-start"
          v-if="showMenu && ($vuetify.breakpoint.xs || $vuetify.breakpoint.sm)"
        >
          <menu-button @click.stop="drawer = !drawer"
                       class="align-self-center"
                       :large="$vuetify.breakpoint.sm"
          />
        </div>

        <nav-logo />
        <div class="d-flex justify-end">
          <nav-menu
            v-if="showMenu && ($vuetify.breakpoint.md ||$vuetify.breakpoint.lg || $vuetify.breakpoint.xl)"
          />
        </div>
      </v-card>
    </div>
  </div>

</template>

<script>
  import NavLink from "./NavLink";
  import MenuButton from "./MenuButton";
  import NavMenu from "./NavMenu";
  import NavLogo from "./NavLogo";

  export default {
    name: "NavBar",
    components: {
      NavMenu,
      MenuButton,
      NavLink,
      NavLogo,
    },
    computed: {
      showMenu() {
        return this.$route.name !== 'login' && this.$route.name !== 'error';
      },
      navBarStyle() {
        if (this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.xl) {
          return 'nav-bar-style px-12';
        } else if (this.$vuetify.breakpoint.sm) {
          return 'nav-bar-style_sm px-4';
      }else if (this.$vuetify.breakpoint.lg){
          return 'nav-bar-style_lg';
        } else {
          return 'nav-bar-style_xs px-2'
        }
      },
    },
    data() {
      return {
        drawer: false,
      }
    },
  }
</script>

<style scoped>
  .nav-bar-style_xs {
    height: 56px;
  }
  .nav-bar-style_sm {
    height: 64px;
  }
  .nav-bar-style {
    height: 80px;
  }
  .nav-bar-style_lg {
    height: 80px;
    padding-right: 80px;
    padding-left: 80px;
  }

  .active-class {
    border-style: none none solid none;
    border-radius: 0;
    border-color: #9b004b;
    background-color: transparent;
    color: #9b004b !important;
  }

  .active-class:before {
    opacity: 0 !important;
  }
</style>
